import React from "react";
import { default as WDialogActions } from "@mui/material/DialogActions";

function DialogActions(props) {
  return <WDialogActions {...props} />;
}

export default DialogActions;
